import React from "react";
import { getValue } from "@utils/lodash";

function MenuAuditSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 24"
      >
        <defs>
          <clipPath id="clip-pathnxas">
            <rect
              id="Rectangle_18182"
              data-name="Rectangle 18182"
              width="24"
              height="24"
              transform="translate(-16173 -8202)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_290"
          data-name="Mask Group 290"
          transform="translate(16173 8202)"
          clip-path="url(#clip-pathnxas)"
        >
          <path
            id="verified_FILL0_wght300_GRAD0_opsz24"
            d="M9.548-4.408l-1.9-3.2L4.038-8.4l.352-3.713-2.446-2.8L4.39-17.7l-.352-3.713,3.609-.79,1.9-3.2,3.4,1.441,3.4-1.441,1.9,3.2,3.609.79L21.5-17.7l2.446,2.8-2.446,2.8L21.851-8.4l-3.609.79-1.9,3.2-3.4-1.441-3.4,1.441Zm.68-2.039L12.944-7.6l2.749,1.15L17.2-9l2.929-.671-.266-3,1.971-2.235-1.971-2.268.266-3L17.2-20.815,15.66-23.369l-2.716,1.15L10.2-23.369,8.683-20.815l-2.929.639.266,3L4.05-14.908l1.971,2.235L5.754-9.639,8.683-9ZM12.944-14.908ZM11.826-11.5l5.65-5.645L16.353-18.3l-4.527,4.523L9.536-16.03,8.413-14.908Z"
            transform="translate(-16173.944 -8175.092)"
            fill={
              getValue(props, `color`, "")
                ? getValue(props, `color`, "")
                : "#5f6368"
            }
          />
        </g>
      </svg>
    </div>
  );
}

export default MenuAuditSvgComponent;
